// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gem3PBcMsQc8oN {
  display: flex;
  position: relative;
  align-items: center;
  min-height: 40px;
  padding: 12px 0;
  column-gap: 12px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
@media only screen and (max-width: 750px) {
  .gem3PBcMsQc8oN {
    flex-flow: row wrap;
  }
}
.GCwqOHh1WTTK8L {
  flex-grow: 1;
}
.GCwqOHh1WTTK8L p {
  margin: 0;
}
.GCwqOHh1WTTK8L strong {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  word-break: break-word;
}
.Q_d8_UUzdf0nBj {
  max-width: 450px;
  overflow-wrap: break-word;
  color: var(--ds-text-subtle, #44546f);
}
.horGpkrJc4GCMc {
  margin-right: 4px;
}
.rOMdQK6lM2ZxFj {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 12px;
}
@media only screen and (max-width: 750px) {
  .rOMdQK6lM2ZxFj {
    flex: 0;
  }
}
.rOMdQK6lM2ZxFj button {
  margin: 0;
}
.rOMdQK6lM2ZxFj .KTu6FGANimg4hQ {
  min-width: 115px;
  margin: 0;
}
.rOMdQK6lM2ZxFj .sl4iCEds7E5TE6 {
  text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberListItemDetail": `gem3PBcMsQc8oN`,
	"details": `GCwqOHh1WTTK8L`,
	"userNameAndLastActiveDate": `Q_d8_UUzdf0nBj`,
	"bulletSeparator": `horGpkrJc4GCMc`,
	"options": `rOMdQK6lM2ZxFj`,
	"option": `KTu6FGANimg4hQ`,
	"orgMemberType": `sl4iCEds7E5TE6`
};
export default ___CSS_LOADER_EXPORT___;
